import React from 'react';
import AboutTitle from './About-comp/AboutTitle';
import Team from './About-comp/Team'


const About = () => {
    return (
        <div>
                <AboutTitle />
                <Team />
        </div>
    )
}

export default About